export const GET_RAINBOW_DATA = 'GET_RAINBOW_DATA'
export const SET_RAINBOW_DATA = 'SET_RAINBOW_DATA'
export const SET_RAINBOW_ERROR = 'SET_RAINBOW_ERROR'
export const SET_RAINBOW_PROCESSING = 'SET_RAINBOW_PROCESSING'

export function getRainbowData () {
  return {
    type: GET_RAINBOW_DATA,
  }
}

export function setRainbowData ({ data, processing = false } = {}) {
  return {
    type: SET_RAINBOW_DATA,
    payload: { data, processing },
  }
}

export function setRainbowError ({ error, processing = false } = {}) {
  return {
    type: SET_RAINBOW_ERROR,
    payload: { error, processing },
  }
}

export function setRainbowProcessing ({ processing = true } = {}) {
  return {
    type: SET_RAINBOW_PROCESSING,
    payload: { processing },
  }
}
